"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var GenericRepo_1 = __importDefault(require("./GenericRepo"));

var FormatsRepo =
/** @class */
function (_super) {
  __extends(FormatsRepo, _super);

  function FormatsRepo() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  FormatsRepo.prototype.listByImporter = function (key) {
    return this.coll.find({
      importer: key
    }).asArray();
  };

  return FormatsRepo;
}(GenericRepo_1.default);

exports.default = FormatsRepo;